/*
 * Pointure obligatoire : aucune pointure n'est présélectionnée.
 * Tant que la cliente n'a pas choisi sa pointure, l'ajout au panier (et « Acheter maintenant »)
 * est bloqué et un message lui demande de choisir.
 * Concerne la fiche produit, l'ajout rapide (popup) et les suggestions du panier.
 */
(() => {
  const SIZE_NAMES = ['pointure', 'pointures', 'taille', 'tailles', 'size', 'sizes'];
  const MESSAGE = 'Choisissez votre pointure';
  const ERROR = 'Veuillez choisir votre pointure';

  const isSizeName = (name) => SIZE_NAMES.includes(String(name || '').replace(/^option-/, '').trim().toLowerCase());

  const style = document.createElement('style');
  style.textContent = `
    .cb-size-hint { margin: 0 0 8px; font-size: 13px; font-weight: 600; }
    .variant-picker__option-name .cb-size-hint { display: inline; margin: 0; font-size: inherit; }
    .cb-size-error .cb-size-hint { color: #b42318; }
    .cb-size-error .variant-picker__option-value label { border-color: #b42318 !important; }
    .cb-size-error { animation: cb-size-shake 0.35s ease; }
    select.cb-size-select-error { border-color: #b42318 !important; outline: 1px solid #b42318; }
    @keyframes cb-size-shake { 0%, 100% { transform: none; } 25% { transform: translateX(-4px); } 75% { transform: translateX(4px); } }
  `;
  document.head.appendChild(style);

  // --- Sélecteur de variantes (fiche produit + popup d'ajout rapide) ---

  function sizeGroups(picker) {
    const groups = [];
    picker.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      if (inputs.length > 1 && isSizeName(inputs[0].name)) groups.push({ el: fieldset, inputs });
    });
    picker.querySelectorAll('select[name^="option-"]').forEach((select) => {
      if (select.options.length > 1 && isSizeName(select.name)) groups.push({ el: select.closest('.variant-picker__option') || select, select });
    });
    return groups;
  }

  function preparePicker(picker) {
    // Déjà choisie par la cliente : le sélecteur re-rendu par le thème garde son choix
    if (picker.dataset.cbSizeChosen) return;

    const groups = sizeGroups(picker);
    if (!groups.length) return;

    picker.dataset.cbSizePending = 'true';

    groups.forEach((group) => {
      if (group.el.querySelector('.cb-size-hint')) return;

      if (group.inputs) {
        group.inputs.forEach((input) => (input.checked = false));
      } else if (group.select && !group.select.querySelector('option[data-cb-placeholder]')) {
        group.select.querySelectorAll('option').forEach((option) => option.removeAttribute('selected'));
        const placeholder = new Option(MESSAGE, '', true, true);
        placeholder.disabled = true;
        placeholder.dataset.cbPlaceholder = 'true';
        group.select.prepend(placeholder);
        group.select.value = '';
      }

      group.el.querySelectorAll('.variant-picker__option-selected-value').forEach((el) => (el.textContent = ''));

      // Message sur la même ligne que « Taille : » ; sinon au-dessus des pointures
      const label = group.el.querySelector('.variant-picker__option-name > span');
      const hint = document.createElement(label ? 'span' : 'p');
      hint.className = 'cb-size-hint';
      hint.textContent = MESSAGE;
      if (label) {
        label.append(hint);
      } else {
        const values = group.el.querySelector('.variant-picker__option-values, .select-wrapper');
        (values || group.el).before(hint);
      }
    });

    if (picker.dataset.cbSizeBound) return;
    picker.dataset.cbSizeBound = 'true';
    picker.addEventListener(
      'change',
      (event) => {
        if (!isSizeName(event.target?.name)) return;
        picker.dataset.cbSizeChosen = 'true';
        delete picker.dataset.cbSizePending;
        picker.querySelectorAll('.cb-size-hint').forEach((el) => el.remove());
        picker.querySelectorAll('.cb-size-error').forEach((el) => el.classList.remove('cb-size-error'));
      },
      { capture: true },
    );
  }

  function pendingPickerFor(element) {
    const scopes = [
      element.closest('product-form'),
      element.closest('form'),
      element.closest('.dialog-modal__content'),
      element.closest('[data-ref="product-section-product-info"]'),
      element.closest('.shopify-section'),
    ];
    for (const scope of scopes) {
      const picker = scope?.querySelector('variant-picker[data-cb-size-pending]');
      if (picker) return picker;
    }
    return null;
  }

  function showPickerError(picker) {
    const groups = sizeGroups(picker);
    groups.forEach((group) => {
      group.el.classList.remove('cb-size-error');
      void group.el.offsetWidth; // relance l'animation
      group.el.classList.add('cb-size-error');
      const hint = group.el.querySelector('.cb-size-hint');
      if (hint) hint.textContent = ERROR;
    });
    groups[0]?.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // --- Suggestions du panier (select de variante des cross-sells) ---

  function prepareCrossSellSelect(select) {
    if (select.dataset.cbSizeReady || select.options.length < 2) return;
    select.dataset.cbSizeReady = 'true';

    const placeholder = new Option('Pointure', '', true, true);
    placeholder.disabled = true;
    placeholder.hidden = true;
    select.prepend(placeholder);
    select.value = '';

    select.addEventListener('change', () => select.classList.remove('cb-size-select-error'));
  }

  function emptyCrossSellSelect(element) {
    const component = element.closest('cross-sell-component');
    if (!component) return null;
    return Array.from(component.querySelectorAll('select[data-ref="variant-select"]')).find((select) => select.value === '') || null;
  }

  // --- Blocage de l'ajout au panier ---

  function block(event, target) {
    const select = emptyCrossSellSelect(target);
    if (select) {
      event.preventDefault();
      event.stopImmediatePropagation();
      select.classList.add('cb-size-select-error');
      select.focus();
      return;
    }

    const picker = pendingPickerFor(target);
    if (picker) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showPickerError(picker);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest(
        '[data-ref="add-to-cart-button"], .shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout',
      );
      if (button) block(event, button);
    },
    { capture: true },
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && /\/cart\/add/.test(form.getAttribute('action') || '')) block(event, form);
    },
    { capture: true },
  );

  // --- Préparation au chargement et à chaque contenu ajouté (popup, panier re-rendu) ---

  function scan(root) {
    root.querySelectorAll?.('variant-picker').forEach(preparePicker);
    root.querySelectorAll?.('cross-sell-component select[data-ref="variant-select"]').forEach(prepareCrossSellSelect);
  }

  scan(document);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('variant-picker')) preparePicker(node);
        scan(node);
        const picker = node.closest('variant-picker');
        if (picker) preparePicker(picker);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
